module.exports = __webpack_public_path__ + "img/ag.2be3ae40.svg";